import React, { useContext, useState } from "react";
// import InputText from "./InputText";
import { AuthContext } from "../contexts/AuthContext";
import InputPassword from "./InputPassword";
import { changePassword } from "../services/my-profile";

export default function DetailsPersonnel() {
  const { user } = useContext(AuthContext);
  // const [prenom, setPrenom] = useState(user.prenom);
  // const [nom, setNom] = useState(user.nom);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [declenched, setDeclenched] = useState(false);

  const passwordChecker = (good) => {
    if (good) {
      changePassword(user, password, setApiResponse);
    } else {
      setApiResponse("Mot de passe différent.");
    }
    setTimeout(() => setDeclenched(true), 7000);
  };

  return (
    <>
      <div className="tyn-profile-details">
        <div className="tab-content">
          <div className="tab-pane show active" id="profile-edit" tabIndex="0">
            <div className="row gy-5">
              <div className="col-12">
                {/* <div className={`row gy-4 `}>
                  <div className="col-lg-3">
                    <h3>Informations personnelles</h3>
                    <div className="tyn-subtext">
                      Modifier les informations personnelles
                    </div>
                  </div>

                  <div className="col-lg-9">
                    <div className="row g-gs">
                      <InputText
                        col="col-lg-6"
                        type="text"
                        className="form-control"
                        label="votre prenom"
                        placeholder="Votre prénom"
                        value={prenom}
                        onChange={(evt) => setPrenom(evt.target.value)}
                      />

                      <InputText
                        col="col-lg-6"
                        type="text"
                        className="form-control"
                        label="Votre nom"
                        placeholder="Votre Nom"
                        value={nom}
                        onChange={(evt) => setNom(evt.target.value)}
                      />
                      <InputText
                        col="col-12"
                        type="text"
                        className="form-control"
                        label="Votre nom utilisateur"
                        placeholder="Votre nom d'utilisateur"
                        value={user.username}
                        readOnly
                      />
                      <div className="tyn-subtext mt-2 text-success mb-4">
                        Vous pouvez aussi utiliser ce nom d'utilisateur pour
                        vous connecter à votre compte.
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="row gy-5" id="change-password">
                  <div className="col-12">
                    <div className="row gy-4">
                      <div className="col-lg-3">
                        <h3>Changez de mot de passe</h3>
                      </div>
                      <div className="col-lg-9">
                        <div className="row g-gs">
                          <InputPassword
                            label="Votre nouveau mot de passe"
                            placeholder="Votre nouveau mot de passe"
                            col="col-lg-6"
                            value={password}
                            onChange={(evt) => {
                              setPassword(evt.target.value);
                            }}
                          />
                          <InputPassword
                            label="Confirmation du nouveau mot de passe"
                            placeholder="Confirmation du nouveau mot de passe"
                            col="col-lg-6"
                            value={passwordConfirm}
                            onChange={(evt) => {
                              setPasswordConfirm(evt.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid mt-3">
          <div className="row">
            <button
              className={`btn btn-primary col-12 ${
                password.length >= 8 && password.length <= 32 && passwordConfirm === password
                  ? ""
                  : " disabled"
              }`}
              onClick={() => passwordChecker(password === passwordConfirm)}
            >
              envoyer
            </button>
            {declenched ? (
              <></>
            ) : (
              <h4
                className={
                  apiResponse.status === 500 || !apiResponse.status
                    ? "text-danger text-center"
                    : "text-success text-center"
                }
              >
                {apiResponse.msg || apiResponse}
              </h4>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
